var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"progress mt-3"},[_c('div',{class:`progress-bar progress-bar-striped ${_vm.animate}`,style:(_vm.progressValueStyle),attrs:{"role":"progressbar","aria-valuenow":_vm.$store.getters.progress,"aria-valuemin":"0","aria-valuemax":_vm.$store.getters.duration}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }